export var LoginType;
(function (LoginType) {
    LoginType["COMPANY"] = "COMPANY";
    LoginType["VENDOR"] = "VENDOR";
    LoginType["ONLINE_CONTRACT"] = "ONLINE_CONTRACT";
})(LoginType || (LoginType = {}));
